import axios from "axios";
import Vue from "vue";

const state = {
  currentSeasonSDGames: null,
  sdGamesByWeek: {},
};

const getters = {
  currentSeasonSDGames(state) { return state.currentSeasonSDGames},
  sdGamesByWeek(state) { return state.sdGamesByWeek },
  latestStartWeekId(state, getters) {
    if (getters.currentSeasonSDGames) {
      return Math.max.apply(Math, getters.currentSeasonSDGames.map( obj => obj.start_week_id));
    }
  },
  currentGame(state, getters) {
    if (getters.latestStartWeekId) {
      return getters.currentSeasonSDGames.filter(game => game.start_week_id === getters.latestStartWeekId)[0];
    }
  },
  prevGames(state, getters) {
    if (getters.latestStartWeekId) {
      return getters.currentSeasonSDGames.filter(game => game.start_week_id !== getters.latestStartWeekId);
    }
  },
};

const actions = {
  getCurrentSeasonSdGames({ commit }) {
    axios.get(process.env.VUE_APP_API_URL + 'sudden_death/get_current_season_sd_games')
    .then(response => {
      commit('SET_CURRENT_SEASON_SD_GAMES', response.data.data.sdGames)
    })
  },
  updatePick({ dispatch }, data) {
    return axios.post(process.env.VUE_APP_API_URL + 'sudden_death/update_pick', data)
    .then(response => {
      dispatch('getCurrentSeasonSdGames');
    })
  },
  getSdWeekInfo({ commit }, weekId) {
    axios.get(process.env.VUE_APP_API_URL + 'sudden_death/week_picks/' + weekId)
    .then(response => {
      let data = {
        weekId: weekId,
        picks: response.data.data.picks
      }
      commit('SET_SD_WEEK', data);
    })
  }
};

const mutations = {
  SET_CURRENT_SEASON_SD_GAMES(state, data) { state.currentSeasonSDGames = data },
  SET_SD_WEEK(state, data) { Vue.set(state.sdGamesByWeek, data.weekId, data.picks) }
};


export default {
  state,
  getters,
  actions,
  mutations,
}
